import React, { useRef } from 'react';
import { FILE_URL } from '../api/axios';

/**
 * Çoklu görsel yükleyici bileşeni
 * items: [{type:'new'|'existing', file?, preview?, id?, image_url?, tempId}]
 * onChange: (newItems) => void
 */
const ImageUploader = ({ items = [], onChange, label = 'Görseller' }) => {
    const dragIndex = useRef(null);
    const fileInputRef = useRef(null);

    const handleFileInput = (e) => {
        const files = Array.from(e.target.files);
        const newItems = files.map(file => ({
            type: 'new',
            file,
            preview: URL.createObjectURL(file),
            tempId: `new_${Date.now()}_${Math.random()}`
        }));
        onChange([...items, ...newItems]);
        e.target.value = '';
    };

    const handleDelete = (index) => {
        const item = items[index];
        if (item.preview) URL.revokeObjectURL(item.preview);
        onChange(items.filter((_, i) => i !== index));
    };

    const handleDragStart = (e, index) => {
        dragIndex.current = index;
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e) => e.preventDefault();

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        const from = dragIndex.current;
        if (from === null || from === dropIndex) return;
        const arr = [...items];
        const [moved] = arr.splice(from, 1);
        arr.splice(dropIndex, 0, moved);
        dragIndex.current = null;
        onChange(arr);
    };

    return (
        <div>
            {label && <label className="form-label">{label}</label>}
            <div className="mb-2 d-flex align-items-center gap-2">
                <input
                    ref={fileInputRef}
                    type="file"
                    className="d-none"
                    multiple
                    accept="image/*"
                    onChange={handleFileInput}
                />
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => fileInputRef.current.click()}
                >
                    + Fotoğraf Ekle
                </button>
                <small className="text-muted">İlk görsel ana görsel. Sürükle-bırak ile sırala.</small>
            </div>
            {items.length > 0 ? (
                <div style={{
                    display: 'flex', flexWrap: 'wrap', gap: '8px',
                    padding: '8px', border: '1px dashed #dee2e6', borderRadius: '6px'
                }}>
                    {items.map((item, index) => {
                        const src = item.type === 'existing'
                            ? `${FILE_URL}/${item.image_url}`
                            : item.preview;
                        return (
                            <div
                                key={item.tempId || item.id}
                                draggable
                                onDragStart={(e) => handleDragStart(e, index)}
                                onDragOver={handleDragOver}
                                onDrop={(e) => handleDrop(e, index)}
                                style={{
                                    position: 'relative', width: '90px', height: '90px',
                                    border: index === 0 ? '2px solid #0d6efd' : '1px solid #dee2e6',
                                    borderRadius: '6px', overflow: 'hidden',
                                    cursor: 'grab', background: '#f8f9fa', flexShrink: 0
                                }}
                            >
                                <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                {index === 0 && (
                                    <span style={{
                                        position: 'absolute', bottom: 0, left: 0, right: 0,
                                        background: 'rgba(13,110,253,0.85)', color: '#fff',
                                        fontSize: '9px', textAlign: 'center', padding: '2px'
                                    }}>Ana Görsel</span>
                                )}
                                <button
                                    type="button"
                                    onClick={() => handleDelete(index)}
                                    style={{
                                        position: 'absolute', top: '2px', right: '2px',
                                        background: 'rgba(220,53,69,0.85)', color: '#fff',
                                        border: 'none', borderRadius: '50%',
                                        width: '20px', height: '20px', fontSize: '13px',
                                        cursor: 'pointer', display: 'flex',
                                        alignItems: 'center', justifyContent: 'center', padding: 0
                                    }}
                                >×</button>
                                <div style={{
                                    position: 'absolute', top: '2px', left: '3px',
                                    color: 'rgba(255,255,255,0.8)', fontSize: '12px', lineHeight: 1
                                }}>⠿</div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <small className="text-muted d-block">Henüz görsel eklenmedi.</small>
            )}
        </div>
    );
};

export default ImageUploader;
